import universal from 'react-universal-component';

export default universal(() => import('./BoxScores'));



// WEBPACK FOOTER //
// ./src/app/views/BoxScores/index.js